import { asyncComponent } from './AsyncComponent';
import { loadBusSched } from './ModuleLoaders';

const TmlScheduleGenerator = asyncComponent(loadBusSched, 'TmlScheduleGenerator');
const ViaPortoScheduleGenerator = asyncComponent(loadBusSched, 'ViaPortoScheduleGenerator');
const CarrisScheduleGenerator = asyncComponent(loadBusSched, 'CarrisScheduleGenerator');
const SmtucScheduleGenerator = asyncComponent(loadBusSched, 'SmtucScheduleGenerator');

export class CustomBusSchedManager {
    getGenerator(name) {
        let generatorComponent = null;

        switch (name.toUpperCase()) {
            case "VIA PORTO":
                generatorComponent = ViaPortoScheduleGenerator;
                break;
            case "CARRIS":
                generatorComponent = CarrisScheduleGenerator;
                break;
            case "TML":
            case "RDL":
                generatorComponent = TmlScheduleGenerator;
                break;
            case "SMTUC":
                generatorComponent = SmtucScheduleGenerator;
                break;
            default:
                break;
        }

        return generatorComponent;
    }

    getGeneratorConfigs(name) {
        let configs = null;

        switch (name.toUpperCase()) {
            case "TML":
            case "RDL":
                configs = {
                    presentReferenceDate: true
                };
                break;
            case "CARRIS":
                configs = {
                    showVersion: true
                };
                break;

            default:
                configs = {};
                break;
        }

        return configs;
    }
}

export const customBusSchedManager = new CustomBusSchedManager();
